import React from 'react';

const Fail = () => (
  <div className="vkboss-payment-cont">
    <p>Во время оплаты произошла ошибка!</p>
  </div>
);

export default Fail;
